// 사용자 그룹(소속) 상수 — users.group_names / 기록 group_name에 이 한글값이 그대로 저장된다.
// 그룹 추가 시 여기에만 넣으면 폼 select·필터 드롭다운에 함께 반영된다.
// (DB 백필·기존 데이터 변경은 scripts/add-user-groups.sql 참고)

export const GROUP_OPTIONS = ['산청우정학사', '안동NAVI', '깨알']
